var _path, _path2, _path3, _circle, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyCategories(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.499 58.5C45.5153 58.5 58.499 45.5163 58.499 29.5C58.499 13.4837 45.5153 0.5 29.499 0.5C13.4828 0.5 0.499023 13.4837 0.499023 29.5C0.499023 45.5163 13.4828 58.5 29.499 58.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6657 43.3333C37.5567 43.3333 42.3324 38.5577 42.3324 32.6667C42.3324 26.7756 37.5567 22 31.6657 22C25.7747 22 20.999 26.7756 20.999 32.6667C20.999 38.5577 25.7747 43.3333 31.6657 43.3333Z",
    fill: "#E7E1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9841 25.5944L40.361 32.9714C41.1421 33.7524 42.4084 33.7524 43.1895 32.9714L48.9706 27.1903C49.7516 26.4092 49.7516 25.1429 48.9706 24.3619L41.5936 16.9849C41.2243 16.6156 40.7253 16.4054 40.2031 16.3992L34.3526 16.3299C33.2296 16.3166 32.3157 17.2304 32.329 18.3534L32.3984 24.2039C32.4046 24.7261 32.6148 25.2252 32.9841 25.5944Z",
    stroke: "#9567F9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.1833,
    cy: 21.1846,
    r: 1.52929,
    transform: "rotate(-45 37.1833 21.1846)",
    stroke: "#9567F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.068 20.4772C23.6871 20.1915 24.3537 20.001 25.1157 20.001C27.7347 20.001 29.8299 22.0962 29.8299 24.7153C29.8299 27.3343 27.7347 29.4295 25.1157 29.4295C22.4966 29.4295 20.4014 27.3343 20.4014 24.7153C20.4014 24.0962 20.4966 23.5248 20.7347 23.001",
    stroke: "#9567F9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.354 41.2393H32.973C33.7349 41.2393 34.354 40.5726 34.2111 39.8107C33.4968 35.3822 29.6873 32.0488 25.1159 32.0488C20.5444 32.0488 16.6873 35.4298 16.0206 39.8107C15.8778 40.5726 16.4968 41.2393 17.2587 41.2393H24.6873",
    stroke: "#9567F9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.068 41.2392C28.068 41.5548 27.8121 41.8106 27.4965 41.8106C27.1809 41.8106 26.9251 41.5548 26.9251 41.2392C26.9251 40.9236 27.1809 40.6678 27.4965 40.6678C27.8121 40.6678 28.068 40.9236 28.068 41.2392Z",
    fill: "#9567F9",
    stroke: "#9567F9",
    strokeWidth: 0.47619
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyCategories);
export default __webpack_public_path__ + "static/media/my-categories.e5be09732bdab9668f07c772795adce6.svg";
export { ForwardRef as ReactComponent };